<ng-template #headerContent>
  <span
    [class]="collapsed() ? 'sr-only' : ' truncate text-start text-sm'"
    >{{ group().label }}</span
  >
  <lib-side-menu-icon name="chevron" [iconClass]="chevronClass()" />
</ng-template>

@if (collapsed()) {
  <button
    type="button"
    [id]="headerId()"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="listId()"
    [libTooltip]="group().label"
    [hasCloseIcon]="false"
    [placement]="tooltipPlacement()"
    [class]="headerClass()"
    (click)="toggle.emit()">
    <ng-container [ngTemplateOutlet]="headerContent" />
  </button>
} @else {
  <div class="flex h-3xl items-center gap-x-sm">
    <button
      type="button"
      [id]="headerId()"
      [attr.aria-expanded]="open()"
      [attr.aria-controls]="listId()"
      [class]="headerClass()"
      (click)="toggle.emit()">
      <ng-container [ngTemplateOutlet]="headerContent" />
    </button>
    @if (group().quickAction; as action) {
      <lib-side-menu-quick-action [key]="key()" [action]="action" />
    }
  </div>
}
@if (open()) {
  <ul [id]="listId()" class="mt-sm flex flex-col gap-x-sm">
    @for (child of children(); track child.id ?? child.label) {
      <li class="ps-md">
        <lib-side-menu-item [item]="child" [collapsed]="collapsed()" />
      </li>
    }
  </ul>
}
